import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-cancel-confirm',
  templateUrl: './event-cancel-confirm.component.html',
  styleUrls: ['./event-cancel-confirm.component.scss']
})
export class EventCancelConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
